<template functional>
  <div :class="[data.class, data.staticClass]" class="page-header-about"><a :href="props.aboutUrl">About</a></div>
</template>
<script>
export default {
  props: ['aboutUrl'],
};
</script>
<style></style>
